<template>
  <scroll-center-dialog v-model="open" :loading="loading || success" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div v-if="!success">
      <div class="field_label__text">ЭЛЕКТРОННАЯ ПОЧТА:</div>
      <v-text-field
          class="dialog__fields"
          color="#3254B9"
          base-color="#313743"
          variant="solo"
          type="email"
          :rules="[rules.email]"
          v-model="data.email"
          :loading="loading"
          :error="hasError('email')"
          :error-messages="getError('email')"
      >
        <template v-slot:label></template>
      </v-text-field>
      <div class="field_label__text">ТЕКУЩИЙ ПАРОЛЬ:</div>
      <v-text-field
          class="dialog__fields"
          color="#3254B9"
          base-color="#313743"
          variant="solo"
          :append-inner-icon="show1 ? 'visibility_off' : 'visibility'"
          :type="show1 ? 'text' : 'password'"
          @click:appendInner="show1 = !show1"
          v-model="data.password"
          :loading="loading"
          :error="hasError('password')"
          :error-messages="getError('password')"
      >
        <template v-slot:label></template>
      </v-text-field>
      <div class="text__field">
        <v-alert
            class="error_alert"
            v-if="error"
            :value="true"
            outline
            :icon="false"
            color="#8f0808"
            variant="outlined"
        >
          {{error.error}}
        </v-alert>
      </div>
    </div>
    <div v-else>
      <div class="field_label__text">
        На указанный вами почтовый адрес отправлено письмо. Для завершения процесса смены почтового адреса перейдите по содержащейся в нем ссылке.
      </div>
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions } from "vuex"

export default {
  name: "UserEmailDialog",
  props: {
    value: Boolean,
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
      show1: false,
      error: null,
      success: false,
      data: {
        email: '',
        password: ''
      },
      rules: {
        email: value => {
          if (value !== null && value !== '') {
            const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Введите адрес электронной почты'
          }
        },
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    },
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
        this.error = null
      },
      deep: true
    }
  },
  computed: {
    form_title () {
      return 'электронная почта'
    },
  },
  methods: {
    ...mapActions({
      changeEmail: 'personal_account/users/changeEmail'
    }),
    save () {
      this.success = false
      this.loading = true
      this.changeEmail({
        data: this.data,
        finalizer: () => {
          this.success = true
          setTimeout(() => {
            this.$emit('save')
            this.loading = false
          }, 3000)
        },
        catcher: (val) => {
          if (val.error) {
            this.error = val
          } else if (val.email && val.email[0] === "user с таким email уже существует.") {
            val.email[0] = "Пользователь с таким адресом электронной почты уже существует."
          }
          this.mapErrors(val)
          this.loading = false
        },
      })
    },
    close () {
      this.$emit('close')
    },
  },
  created () {}
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

.error_alert {
  border-radius: 10px;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
}

.text__field {
  margin: 0 auto;
  width: 100%;
  max-width: 520px;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }
}
</style>
